const localizers = {
  'loading.msg': () => `Chargement en cours...`,
  'logon.message.msg': () => `Authentification requise. Saisissez un ID utilisateur et un mot de passe valides.`,
  'logon.button.msg': () => `Connexion...`,
  'SASServer.logonError.msg': () => `Impossible de se connecter au serveur.`,
  'SASServer.genericError.msg': () => `Le serveur est inaccessible.`,
}
export default localizers;
